registerGlobal('EmscriptenUrlData');

EmscriptenUrlData.getParams = function() {
    try {
        var search = location.search.substring(1);
        return search?JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
                         function(key, value) { return key===""?value:decodeURIComponent(value) }):{};
    } catch(e) {
        return {};
    }
}

EmscriptenUrlData.getParamsArray = function() {
    try {
        var params = EmscriptenUrlData.getParams();
        var result = [];
        for (var property in params) {
            if (!params.hasOwnProperty(property)) continue;
            result.push(property);
            result.push(params[property]);
        }
        return result;
    } catch(e) {
        return [];
    }
}



//////////////////
// WEBPACK FOOTER
// /src/contrib/huuugelibs/src/network/url_data/emscripten/js/Application.urldata.js
// module id = 56
// module chunks = 0